module.exports = __webpack_public_path__ + "static/img/jinri.a43caf58.png";